export default __webpack_public_path__ + "6512fca3e9a99e40ae1711e48f908075.png";